
export default () => {
  onmessage = event => {
    if (!event) return;
    const { response } = event.data;
    const { chartData } = response;
    let excelHeaders = [];
    let excelData = [];

    if (chartData && chartData[0]?.x) {
     
      excelHeaders = [{ key: "TimeStamp", header: "TimeStamp", width: 15 }].concat(
        chartData.map(function (item) {
          return { key: item.name, header: item.name, width: 15 };
        })
      );

      excelData = chartData[0].x.map((TimeStamp, idx) => {
        const rowData = chartData.reduce(
          (acc, item) => {
            acc[item.name] = item.y[idx];
            return acc;
          },
          { TimeStamp }
        );
        return rowData;
      });
    }

    postMessage({ excelHeaders, excelData });
  };
};
